import { FormattedMessage, useIntl } from 'react-intl';
import React from 'react';

export const Translate = (id, values = {}) => {
    return <FormattedMessage id={id} values={values}  />;
};

export const TranslateW = (id) => {
    const intl = useIntl();
    return intl.formatMessage({id})
};